import { FlexGrid } from 'yoso';
import { levelMetaMap } from '~/components/Level/Level.hooks';
import { LevelStatusCard } from '~/components/Level/Status/LevelStatusCard';
import './LevelStatusCardList.scss';

export const LevelStatusCardList = () => (
  <FlexGrid container className="level-status-card-list">
    {Object.values(levelMetaMap).map((levelMeta) => (
      <FlexGrid key={levelMeta.level}>
        <LevelStatusCard {...levelMeta} />
      </FlexGrid>
    ))}
  </FlexGrid>
);
